import React, { useState,useEffect,useRef, useCallback } from 'react';
import { AnimatePresence,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react'

import '../../lib/bootstrap.min.css'
import '../Main.css';
import '../SubPage.css';
import '../Property.css';

const PhotoGallery = (props) => {
    const refContent = useRef(null);
    const [cheight,setcHeight] = useState(0)
    const [cwidth,setcWidth] = useState(0)
    const [emblaRef, emblaApi] = useEmblaCarousel()
    const [prevDisable,setPrevDisable] = useState(false)
    const [nextDisable,setNextDisable] = useState(false)

    const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
    }, [emblaApi])

    const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])
    const scrolTo = useCallback((index) => {
        if (emblaApi) emblaApi.scrollTo(index)
    }, [emblaApi])


    useEffect(() => {
        setcHeight(refContent.current.clientHeight);
        setcWidth(refContent.current.clientWidth);
    }, []);

  return (
     <motion.div ref={refContent} style={{height:props.height}}>
        <div className="embla">
            
                    <div className="embla__viewport" ref={emblaRef} onFocus={()=>{document.getElementById('next').focus()}}>
                        <div className="embla__container">
                        {props.content.map((gallery,key)=>(
                            <>
                                {gallery &&
                                    <div className="embla__slide" key={key} style={{height:props.height}}>
                                        <img src={gallery} style={{width:'100%'}} />
                                    </div>
                                }
                            </>
                        ))}
                        </div>
                    </div>
            <div className='embla__nav'>
                <button id='prev' className="embla__prev btnFNB" onClick={scrollPrev} disabled={prevDisable}>
                    &laquo; Prev
                </button>
                <button id='next' className="embla__next btnFNB" onClick={scrollNext} disabled={nextDisable}>
                    Next &raquo;
                </button>
            </div>
        </div>
    </motion.div>
  )};

export default PhotoGallery;


